<template>
  <div class="vaccine-details">
    <div class="d-flex modal-title-head">
      <div class="title-head">
        <p
          style="text-align: center"
          v-html="
            update
              ? $t('dashboard.grid.editUser')
              : $t('dashboard.grid.addUser')
          "
        />
      </div>
      <svg
        class="closeAddUserModal"
        @click="setResetModal"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <form-wizard
      class="user-custom-form-wizard form"
      ref="user-wizard"
      color="none"
      step-size="xs"
    >
      <tab-content>
        <!-- user image  -->
        <div class="user-avatar text-center vp-mb-40" v-if="!isDefaultUser">
          <button
            v-if="!image.url"
            type="button"
            @click="pickImage"
            class="camera-BG text-center"
            :class="{ 'red-border': imageError }"
          >
            <b-form-file
              accept="image/*"
              id="imagePicker"
              ref="userImageRef"
              class="d-none"
            ></b-form-file>
            <span class="d-block"
              ><i class="mdi mdi-camera no-user-camera"></i
            ></span>
          </button>
          <div v-else>
            <img
              :src="image.url"
              :key="Math.random()"
              class="hasImage userImage"
            />
            <div class="img-bg__cover"></div>
            <!-- <b-form-file accept="image/*" id="imagePicker" class="d-none"/> -->
            <span class="d-block text-center">
              <i
                type="button"
                @click="removeUserImage()"
                class="remove-user-image-btn"
                >{{ $t("common.remove") }}</i
              >
            </span>
          </div>
        </div>

        <!-- Start :: personal user informatoin -->
        <div class="personal-user-informatoin">
          <div class="default-user">
            <h5 v-if="!isDefaultUser" class="vp-mb-32 main-section">
              {{ mainSectionTitle }}
            </h5>
            <div class="userTypes-users">
              <div v-if="!isDefaultUser" class="vp-mb-16">
                <vp-treeselect
                  :clearOnSelect="false"
                  width="416"
                  :showPlaceholderIcon="true"
                  :placeholder="$t('common.userType')"
                  :isMultiple="false"
                  :isLoading="isSectionDataLoading"
                  :disabled="!userTypes.length || isSectionDataLoading"
                  :options="userTypes"
                  :isRequired="false"
                  :allowEmpty="false"
                  v-model="$v.form.user.user_type_id.$model"
                  @search-change="searchWithUserType"
                  @select="enableSaveButton(), updateSection($event)"
                  :label="$t('common.userType')"
                />
              </div>
            </div>

            <div>
              <div class="form-group m-d-gruop">
                <vp-input
                  :label="$t('common.firstName')"
                  width="416"
                  id="firstName"
                  :class="{
                    'not-allowed-cursor': form.user.first_name.length >= 20,
                  }"
                  v-model="$v.form.user.first_name.$model"
                  type="text"
                  maxlength="20"
                  @input="checkDuplicationData('first_name')"
                />
              </div>
              <div
                class="twenty-characters-error"
                v-if="form.user.first_name && form.user.first_name.length > 20"
              >
                First name can't exceed 20 characters.
              </div>
            </div>

            <div>
              <div :class="!isDefaultUser ? 'form-group m-d-gruop' : ''">
                <vp-input
                  :label="$t('common.lastName')"
                  width="416"
                  id="lastName"
                  :class="{
                    'not-allowed-cursor': form.user.last_name.length >= 20,
                  }"
                  v-model="$v.form.user.last_name.$model"
                  type="text"
                  maxlength="20"
                  @input="checkDuplicationData('last_name')"
                />
              </div>
              <div
                class="twenty-characters-error"
                v-if="form.user.last_name && form.user.last_name.length > 20"
              >
                Last name can't exceed 20 characters.
              </div>
            </div>
          </div>
          <div v-if="form.user.system_user" class="systemUserHint">
            <hr />
            <p class="rfid-notes">
              {{ $t("common.add") }} {{ $t("common.emailAddress") }}
              {{ $t("common.or") }} {{ $t("common.phoneNumber") }}
            </p>
          </div>

          <div v-if="!isDefaultUser" class="all-user-data">
            <!-- email   -->
            <div
              class="email-address"
              :class=" emailErrorMessage || validEmailMessage ? 'vp-mb-0' : 'vp-mb-16'"
            >
              <vp-input
                id="email"
                :label="
                  form.user.system_user
                    ? $t('common.emailAddress')
                    : $t('common.emailAddressOptional')
                "
                :invalid="emailErrorMessage || validEmailMessage"
                :isLoading="emailLoading"
                width="416"
                v-model="$v.form.user.email.$model"
                type="text"
                @input="checkDup('email')"
              />
              <!-- <div class="spinner-border phone-email-loader" role="status" v-if="emailLoading"></div> -->
            </div>
            <p v-if="emailErrorMessage" class="error-message">
              {{ $t('common.notes.emailAddressAlreadyExists')}}
            </p>
            <p v-if="validEmailMessage" class="error-message">
              {{ $t('common.notes.enterValidEmailMessage') }}.
            </p>

            <div v-if="update && currentPhone">
              <div class="d-flex">
                <div class="phone-number-1 vp-mb-16 generate-user-id">
                  <vp-input
                    id="phoneNumber"
                    :label="$t('common.phoneNumber')"
                    width="285"
                    v-model="form.user.phone"
                    type="phone"
                    disabled
                  />
                </div>
                <button
                  @click="onChangeToUpdatePhone"
                  pill
                  class="generate-user-id-btn"
                >
                  {{ $t("common.change") }}
                </button>
              </div>
            </div>

            <div v-else class="phone-input-wrapper">
              <VueCountryCode
                class="code-input"
                :disabledFetchingCountry="false"
                @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true"
                :preferredCountries="['GB', 'US', 'CN']"
                :class="phoneErrorMessage ? 'is-invalid' : ''"
              />
              <div
                class="phone-number-2 vp-ml-10"
                :class="phoneErrorMessage ? 'is-invalid' : ''"
              >
                <vp-input
                  id="phoneNumber"
                  :label="
                    form.user.system_user
                      ? $t('common.phoneNumber')
                      : $t('common.phoneNumberOptional')
                  "
                  width="285"
                  :invalid="phoneErrorMessage"
                  :isLoading="phoneLoading"
                  v-model="userPhone"
                  type="number"
                  @input="checkDup('phone'), touchUserPhone()"
                />
              </div>
            </div>
            <p v-if="phoneErrorMessage" class="error-message">
              {{ $t("common.notes.phoneNumberAlreadyExists") }}
            </p>

            <hr v-if="form.user.system_user" class="vp-mt-1 vp-mb-17" />
            <div class="d-flex">
              <div
                class="form-group m-d-gruop generate-user-id"
                :class="
                  form.user.user_user_id && userIdErrorMessage
                    ? 'is-invalid'
                    : ''
                "
              >
                <vp-input
                  id="userId"
                  :label="$t('common.id')"
                  width="285"
                  rightPosition="155"
                  :isLoading="userIdLoading"
                  v-model="$v.form.user.user_user_id.$model"
                  type="text"
                  @input="checkDuplicationData('user_user_id')"
                />
              </div>
              <button
                :disabled="
                  form.user.user_user_id && duplicateUserIdGenerated
                    ? true
                    : false
                "
                @click="generateUserID"
                pill
                class="generate-user-id-btn"
              >
                {{ $t("common.generate") }}
              </button>
            </div>
            <p
              v-if="form.user.user_user_id && userIdErrorMessage"
              class="error-message"
            >
              {{ $t("common.notes.idAlreadyExists") }}
            </p>

            <div id="rfid" class="mb-16">
              <div
                class="rfid-tag d-flex"
                :class="rfidsLoading ? 'activeLoader' : ''"
              >
                <span
                  v-if="form.user.rfidArr && form.user.rfidArr.length > 0"
                  class="selections-label"
                  >{{ $t("common.RFID") }}
                  {{ $t("common.optionalWithBrackets") }}</span
                >
                <multiselect
                  id="rfid-tag"
                  class="rfid-tags"
                  v-model="$v.form.user.rfidArr.$model"
                  :options="[]"
                  :placeholder="
                    !form.user.rfidArr || form.user.rfidArr.length == 0
                      ? `${$t('common.RFID')} ${$t(
                          'common.optionalWithBrackets'
                        )}`
                      : ''
                  "
                  :show-labels="false"
                  :taggable="true"
                  @remove="removeTag"
                  @tag="addTag"
                  :tagPlaceholder="$t('common.tagPlaceholder')"
                  :showNoResults="true"
                  multiple
                  >
                  <span slot="noOptions">{{$t('common.emptList')}}</span>
                </multiselect>
                <div
                  class="spinner-border"
                  style="margin-inline-start: -40px"
                  role="status"
                  v-if="rfidsLoading"
                ></div>
              </div>
              <p class="rfid-notes">
                <b>{{ $t("common.notes.note") }}: </b>
                {{ $t("common.notes.rfidNote") }}
              </p>
            </div>
            <div id="label" v-if="!isDefaultUser">
              <div
                class="label-tag d-flex"
                :class="rfidsLoading ? 'activeLoader' : ''"
              >
                <div
                  v-if="form.user.labelArr && form.user.labelArr.length > 0"
                  class="selections-label d-flex"
                >
                  {{ $t("common.label") }}
                  {{ $t("common.optionalWithBrackets") }}
                </div>
                <multiselect
                  id="rfid-tag"
                  class="rfid-tag"
                  v-model="$v.form.user.labelArr.$model"
                  :options="allLabelsArr"
                  :placeholder="
                    !form.user.labelArr || form.user.labelArr.length == 0
                      ? `${$t('common.label')} ${$t(
                          'common.optionalWithBrackets'
                        )}`
                      : ''
                  "
                  :show-labels="false"
                  :taggable="true"
                  @tag="addLabelTag"
                  :tagPlaceholder="$t('common.tagPlaceholder')"
                  @select="checkOnUpdate = false"
                  @remove="checkOnUpdate = false"
                  multiple
                  :showNoResults="false"
                  :allowEmpty="true"
                >
                <span slot="noOptions">{{$t('common.emptList')}}</span>
                </multiselect>
              </div>
            </div>
          </div>
        </div>
        <!-- End :: personal user informatoin -->
      </tab-content>

      <tab-content v-for="(section, index) in customSections" :key="index">
        <RenderFieldType
          :addSeperator="true"
          :section="section"
          @updateCustomField="updateCustomField"
        />
      </tab-content>

      <!-- Wizard footer -->
      <div
        :class="{ 'back-next-dots': customSections && customSections.length }"
        slot="footer"
        slot-scope="props"
      >
        <div style="position: relative; bottom: 0">
          <div class="right-left-position">
            <div
              class="wizard-footer-left"
              :class="{ 'left-align': props.activeTabIndex > 0 }"
              v-if="customSections && customSections.length"
            >
              <wizard-button
                :disabled="props.activeTabIndex == 0"
                @click.native="props.prevTab()"
                class="back-btn"
                :style="props.fillButtonStyle"
              >
                {{ $t("common.back") }}
              </wizard-button>
            </div>
            <div
              class="wizard-footer-right"
              :class="{ 'right-align': props.activeTabIndex > 0 }"
              v-if="customSections && customSections.length"
            >
              <wizard-button
                :disabled="
                  props.isLastStep ||
                  $v.form.user.$invalid ||
                  (props.activeTabIndex >= 1 &&
                    $v.customSections.$each.$iter[props.activeTabIndex - 1]
                      .$invalid) ||
                  emailLoading ||
                  (!emailLoading && (emailErrorMessage || validEmailMessage))
                "
                @click.native="props.nextTab()"
                class="next-btn"
                :style="props.fillButtonStyle"
              >
                {{ $t("common.next") }}
              </wizard-button>
            </div>
          </div>
          <div class="vp-pt-40 d-flex justify-content-center">
            <wizard-button
              class="add-edit-wizard"
              :style="props.fillButtonStyle"
              :disabled="
                $v.form.user.first_name.$invalid ||
                $v.form.user.last_name.$invalid ||
                !form.user.user_type_id ||
                submitted ||
                checkRfid ||
                validEmailMessage ||
                checkOnUpdate ||
                !form.user.user_user_id ||
                phoneErrorMessage ||
                emailErrorMessage ||
                userIdErrorMessage ||
                rfidMessage
                  ? true
                  : form.user.system_user == 1 &&
                    !form.user.email &&
                    !form.user.phone
                  ? true
                  : false ||
                    isSectionDataLoading ||
                    !$v.$anyDirty ||
                    $v.customSections.$invalid
              "
              @click.native="onSubmit()"
            >
              <!-- <i
          class="bx bx-hourglass bx-spin font-size-16 align-middle mr-2 wizard-submit-button"
          ></i> -->
              {{ actionText }}
            </wizard-button>
          </div>
        </div>
      </div>
    </form-wizard>

    <!-- <div class="action-btns">
      <button @click="onSubmit()" :disabled="$v.form.user.first_name.$invalid || $v.form.user.last_name.$invalid ||!form.user.user_type_id || submitted || checkRfid || validEmailMessage || checkOnUpdate
      || !form.user.user_user_id || phoneErrorMessage || emailErrorMessage || userIdErrorMessage || rfidMessage ? true : form.user.system_user == 1 && (!form.user.email && !form.user.phone) ? true : false" type="submit" class="add-document-btn btn btn-primary" size="lg">{{ actionText }}</button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  required,
  between,
  numeric,
  requiredIf,
  maxLength,
  email,
} from "vuelidate/lib/validators";
import store from "@/state/store";
import VueCountryCode from "vue-country-code";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import userTypeService from "@/services/userType";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import RenderFieldType from "@/components/users/section/RenderFieldType";
import sectionService from "@/services/section";
import { cloneDeep, debounce } from "lodash";
import { getCustomFieldsPayload } from "@/utils/mixins/customFieldValueParser";

export default {
  name: "UserForm",
  components: {
    VueCountryCode,
    FormWizard,
    TabContent,
    WizardButton,
    RenderFieldType,
  },
  props: ["data", "cropImageData", "allLabels"],
  // mixins:[getCustomFieldValueMixin],
  data() {
    return {
      mainSectionTitle: "",
      isSectionDataLoading: false,
      customSections: [],
      allLabelsArr: [],
      form: {
        user: {
          id: null,
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          image: "",
          is_image_changed: false,
          user_type_id: null,
          rfid_number: "",
          user_user_id: "",
          system_user: false,
          department_id: "",
          role_id: null,
          is_revoked: false,
          company_name: "",
          vehicle_registration: "",
          current_entity: {},
          rfidArr: [],
          rf_ids: [],
          labelArr: [],
        },
        entity: {
          entity_id: null,
        },
      },
      actionText: this.$t("common.addUpperCase"),
      imageToDisplay: null,
      hasPassword: null,
      userTypes: [],
      roles: [],
      departments: [],
      submitted: false,
      update: false,
      backup: false,
      imageSizeError: "",
      userProfile: null,
      hasImage: false,
      imgSpinner: false,
      userCountryCode: null,
      countryCodeChanged: false,
      imgMinSizeErr: false,
      userPhone: null,
      currentPhone: true,
      userRole: null,
      emailErrorMessage: false,
      phoneErrorMessage: false,
      userIdErrorMessage: false,
      rfidErrorMessage: false,
      phoneLoading: false,
      emailLoading: false,
      userIdLoading: false,
      rfidsLoading: false,
      openAndCloseUserRoleList: true,
      rfidMessage: false,
      checkRfid: false,
      duplicateUserIdGenerated: false,
      validEmailMessage: false,
      checkOnUpdate: false,
      showUserTypeLabel: false,
      regEmail:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      user_roles_list: [
        { id: "Admin", name: "Admin" },
        { id: "Employee", name: "Employee" },
        { id: "Fire warden", name: "Fire warden" },
      ],
      imageError: false,
      imageUrl: null,
      image: {
        size: "",
        height: "",
        width: "",
        url: "",
      },
    };
  },
  validations: {
    customSections: {
      $each: {
        custom_fields: {
          $each: {
            value: {
              required: requiredIf(function (field) {
                return field.is_mandatory;
              }),
              textMaxLength: function (field, parentField) {
                if (parentField.type != "text") return true;
                if (field?.length > 20) return false;
                return true;
              },
            },
          },
        },
      },
    },
    form: {
      user: {
        first_name: { required, maxLength: maxLength(20) },
        last_name: { required, maxLength: maxLength(20) },
        email: {
          email,
          required: requiredIf(function () {
            const {
              form: {
                user: { phone, system_user },
              },
            } = this;
            return system_user && !phone;
          }),
        },
        phone: {},
        company_name: {
          maxLength: maxLength(30),
        },
        vehicle_registration: {
          maxLength: maxLength(30),
        },
        user_type_id: { required },
        user_user_id: { required },
        system_user: {
          required,
          between: between(0, 1),
        },
        rfidArr: {},
        labelArr: {},
        is_image_changed: {},
      },
    },
    userPhone: {
      required: requiredIf(function () {
        const {
          form: {
            user: { email, system_user, phone },
          },
        } = this;
        return system_user && !email && !phone;
      }),
      numeric,
    },
  },
  computed: {
    ...mapGetters("users", [
      "getLoading",
      "getUserRoles",
      "getDepartments",
      "getFormErrors",
      "getModalState",
    ]),
    ...mapGetters("userType", ["getAllUsersTypes"]),
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("authfack", [
      "currentEntity",
      "userDetails",
      "getCurrentPlan",
    ]),
    ...mapGetters("entity", ["getCropImageData"]),

    getPhone() {
      return `${this.userCountryCode}${this.form.user.phone}`;
    },
    isDefaultUser() {
      return this.getModalInfo?.current_entity?.is_default_user || false;
    },
  },
  created() {
    this.checkDup = debounce(this.checkDuplicationData.bind(this), 500);
  },
  watch: {
    async "form.user.user_type_id"(userTypeId) {
      this.customSections = null;
      document.querySelector(".wizard-nav-pills").style.display = "none";
      document.querySelector(".wizard-progress-bar").style.display = "none";

      if (!userTypeId) return (this.customSections = []);
    },

    // "form.user.image"(imgObj) {
    //   if (typeof imgObj == "object") {
    //     this.imageToDisplay = URL.createObjectURL(imgObj);
    //   }
    // },
    getModalState(state) {
      state == true && this.$bvModal.hide("add-edit-user");
    },
    userRole(role) {
      if (role && role.id == "System User") {
        this.form.user.system_user = true;
      } else {
        this.form.user.system_user = false;
      }
    },
    userPhone(phone) {
      if (phone && phone.length > 0) {
        this.form.user.phone = `${this.userCountryCode}${phone}`;
      } else {
        this.form.user.phone = null;
      }
    },
    async cropImageData(file) {
      console.log("fileeeee2", file);

      if (file) {
        this.imageError = false;
        this.image.width = "";
        this.image.height = "";
        this.image.url = "";

        // if (!file || file.type.indexOf("image/") !== 0) return this.imageError = true ;
        if (file.width < 200 || file.height < 45 || file.size > 2097152)
          return (this.imageError = true);

        this.image.size = await file.size;
        this.image.width = await file.width;
        this.image.height = await file.height;
        this.image.url = await file.cropedImage;
        // console.log('this.image',this.image);
        this.form.user.image = await file.blobFile;
        this.$v.form.user.is_image_changed.$model = true;
        console.log("this.form.user.image", this.form.user.image);
      }
    },
  },
  async mounted() {
    document.querySelector(".wizard-nav-pills").style.display = "none";
    document.querySelector(".wizard-progress-bar").style.display = "none";

    this.fetchUserRoles();
    this.fetchDepartments();
    Object.keys(this.$route.params).length > 1
      ? (this.form.user.user_type_id = this.$route.params)
      : "";
    this.allLabelsArr = this.allLabels.map((item) => {
      return item.name;
    });
    this.updateUserInformation();
    if (this.update && !this.isDefaultUser) {
      this.setSections(this.form.user.user_type_id, true);
    }

    setTimeout(() => {
      this.$v.$reset();
    }, 0);
  },
  methods: {
    ...mapActions("authfack", ["fetchuserDetails"]),
    ...mapActions("users", [
      "createUser",
      "updateUserAction",
      "fetchUserRoles",
      "fetchDepartments",
      "addLabel",
    ]),
    ...mapActions("visit", ["fetchUsersByEmailOrPhone"]),
    touchUserPhone() {
      this.$v.userPhone.$touch();
    },
    updateSection(userType) {
      if (
        !userType ||
        userType?.id == this.form.user.user_type_id ||
        this.isDefaultUser
      )
        return;
      this.setSections(userType.id, false);
    },
    async setSections(userTypeId, isUpdate) {
      // Indicate that loading has started
      this.isSectionDataLoading = true;

      try {
        // Fetch custom sections data asynchronously
        const response = await sectionService.getCustomField(
          userTypeId,
          isUpdate ? this.data?.current_entity?.id : 0
        );
        const customSectionsData = response.data || [];

        // Update the custom sections with potentially modified default values
        this.customSections = customSectionsData.map((section) => ({
          ...section,
          custom_fields: section.custom_fields.map((field) => ({
            ...field,
            value: this.determineDefaultValue(field, isUpdate),
          })),
        }));

        // Check if there are custom sections to display
        if (this.customSections.length > 0) {
          // Ensure elements exist before attempting to manipulate styles
          const navPills = document.querySelector(".wizard-nav-pills");
          const progressBar = document.querySelector(".wizard-progress-bar");

          if (navPills && progressBar) {
            navPills.style.display = "flex";
            progressBar.style.display = "block";
          }
        }
      } catch (error) {
        console.error("Failed to fetch or process custom sections:", error);
      } finally {
        // Indicate that loading has completed, regardless of success or failure
        this.isSectionDataLoading = false;
      }
    },
    //isUpdate = false means all custom_fields will be set to their default values
    determineDefaultValue(field, isUpdate = false) {
      let defaultValue = null;

      switch (field.type) {
        case "checkboxes":
          try {
            defaultValue = isUpdate
              ? JSON.parse(field.custom_field_value.value)
              : [];
          } catch (error) {
            console.warn("Failed to parse JSON for checkboxes:", error);
            defaultValue = [];
          }
          break;
        case "toggleButton":
          defaultValue = isUpdate
            ? field?.custom_field_value?.value === "1" ||
              field?.custom_field_value?.value === "true"
            : false;
          break;
        default:
          defaultValue = isUpdate ? field?.custom_field_value?.value : null;
          break;
      }

      return defaultValue;
    },
    updateCustomField(field) {
      this.$v.customSections.$touch();
      this.customSections?.forEach((section, sectionIndex) => {
        let updatedFieldIndex = section.custom_fields?.findIndex(
          (customField) => customField.id == field.id
        );
        if (updatedFieldIndex >= 0)
          this.customSections[sectionIndex].custom_fields[updatedFieldIndex] =
            field;
      });

      this.customSections = cloneDeep(this.customSections);
    },
    addLabelTag(newTag) {
      this.$v.form.user.labelArr.$touch();
      this.checkOnUpdate = false;
      const labelExist = this.form.user.labelArr.find(
        (label) => label == newTag
      );
      if (!labelExist) {
        this.form.user.labelArr.push(newTag);
      }
    },
    updateUserInformation() {
      if (this.getModalInfo && Object.keys(this.getModalInfo).length) {
        console.log("update", this.getModalInfo);
        let entity = store.getters["authfack/currentEntity"];
        const user = this.form.user;
        const image = this.image;
        const userData = this.getModalInfo;
        user.current_entity = userData.current_entity;
        let rf_ids = [];
        if (user.current_entity) {
          this.update = true;
          user.user_type_id = userData.current_entity.user_type_id;
          user.phone = userData.phone;
          user.role_id = userData.current_entity.role;
          user.id = userData.current_entity.user_id;
          user.is_revoked =
            userData.current_entity.is_revoked == 0 ||
            userData.current_entity.is_revoked == 3
              ? true
              : false;
          this.hasPassword =
            userData.current_entity && userData.current_entity.hasPassword;

          // console.log('user.current_entity', user.current_entity);

          let imageProfile = userData.image;
          if (imageProfile) {
            imageProfile = imageProfile.replace("entity_id", entity.id);
          }
          this.imageToDisplay = imageProfile;

          if (userData.current_entity && userData.current_entity.image) {
            user.image = userData.current_entity.image;
            user.is_image_changed = false;
            image.url = userData.current_entity.image;
          }
          this.actionText = this.$t("common.saveChanges");
          this.checkOnUpdate = true;

          if (userData.backup) {
            this.checkOnUpdate = false;
          }

          user.rf_ids = userData.rf_ids;

          if (userData.rf_ids.length) {
            userData.rf_ids.map((obj) => {
              rf_ids.push(obj.mapping_value);
            });
          }
        } else {
          user.user_type_id = userData.user_type;
          user.phone = userData.phone;
          user.role_id = userData.role_id;

          rf_ids = userData.rfidArr;

          if (userData.image) {
            user.is_image_changed = true;
            user.image = userData.image;
            this.image.size = userData.size;
            this.image.height = userData.height;
            this.image.width = userData.width;
            this.image.url = userData.url;
          }
        }

        // console.log('rf_idsrf_ids',rf_ids);

        user.user_user_id = userData.user_user_id;
        if (userData.user_user_id) {
          this.duplicateUserIdGenerated = true;
        }
        user.system_user = userData.system_user == 1 ? true : false;

        user.rfidArr = rf_ids;
        user.labelArr = [];
        userData.labels?.map((item) => {
          const labelExist = this.allLabels.find(
            (label) => label.id == item.mapping_value
          );
          user.labelArr.push(labelExist.name);
        });
        // personal info
        user.first_name = userData.first_name;
        user.last_name = userData.last_name;
        user.email = userData.email;

        // console.log('userPhone',this.userPhone);

        user.company_name = userData.company_name;
        user.vehicle_registration = userData.vehicle_registration;

        // hide current phone wrapper if phone is null.
        if (!userData.phone) {
          this.currentPhone = false;
        }
        if (userData.system_user == 1) {
          this.userRole = { id: "System User", name: "System User" };
        }
        console.log("this.this.form.user", this.form.user);
      }
    },
    generateUserID() {
      let length = 8,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      let i = 0,
        n = charset.length;
      for (; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      this.form.user.user_user_id = "VP-" + retVal;
      this.checkDuplicationData("user_user_id");
    },
    async addTag(newTag) {
      // console.log("newTag", newTag);
      this.checkRfid = true;
      this.checkOnUpdate = false;
      if (
        newTag &&
        !this.form.user.rfidArr?.includes(newTag) &&
        !isNaN(newTag)
      ) {
        this.$v.form.user.rfidArr.$touch();
        this.rfidsLoading = true;
        this.rfidMessage = false;
        let formData = new FormData();
        formData.append("entity_id", this.currentEntity.id);
        formData.append("user_id", this.form.user.id ? this.form.user.id : "");
        formData.append("field", "rfid_number");
        formData.append("value", newTag);
        await this.fetchUsersByEmailOrPhone(formData).then((data) => {
          if (data.data.available) {
            this.form.user.rfidArr.push(newTag);
          } else {
            this.rfidMessage = true;
          }
          this.rfidsLoading = false;
        });
      }
      this.checkRfid = false;
    },
    checkDuplicationData(type) {
      let value = "";
      this.checkOnUpdate = false;
      this.phoneLoading = false;
      this.emailLoading = false;
      this.userIdLoading = false;
      this.submitted = true;

      if (type == "email") {
        this.validEmailMessage = false;
        this.emailLoading = true;
        this.emailErrorMessage = false;
        value = this.form.user.email;
      } else if (type == "phone") {
        this.phoneLoading = true;
        this.phoneErrorMessage = false;
        value = this.userPhone ? this.userCountryCode + this.userPhone : "";
      } else if (type == "user_user_id") {
        this.duplicateUserIdGenerated = true;
        this.userIdLoading = true;
        this.userIdErrorMessage = false;
        value = this.form.user.user_user_id;
      }

      // console.log('value', value);

      if (type && value && value.length > 0) {
        if (type == "email") {
          let checkStringIsEmail = this.validateEmail(value);
          if (!checkStringIsEmail) {
            this.validEmailMessage = true;
            this.emailLoading = false;
            return;
          }
        }
        let formData = new FormData();
        formData.append("entity_id", this.currentEntity.id);
        formData.append("user_id", this.form.user.id ? this.form.user.id : "");
        formData.append("field", type);
        formData.append("value", value);
        setTimeout(async () => {
          await this.fetchUsersByEmailOrPhone(formData).then((data) => {
            if (!data.data.available) {
              if (data.data.field == "email") {
                this.emailErrorMessage = true;
              } else if (data.data.field == "phone") {
                this.phoneErrorMessage = true;
              }
              if (data.data.field == "user_user_id") {
                this.duplicateUserIdGenerated = false;
                this.userIdErrorMessage = true;
              }
            } else if (data.data.field == "email") {
              this.emailErrorMessage = false;
            } else if (data.data.field == "phone") {
              this.phoneErrorMessage = false;
            }
            this.emailLoading = false;
            this.phoneLoading = false;
            this.userIdLoading = false;
            this.submitted = false;
          });
        }, 2000);
      } else {
        this.phoneLoading = false;
        this.emailLoading = false;
        this.userIdLoading = false;
        this.submitted = false;
      }
    },
    validateEmail(email) {
      let isEmailForm = false;
      if (this.regEmail.test(email)) {
        isEmailForm = true;
      }
      return isEmailForm;
    },
    enableSaveButton() {
      this.checkOnUpdate = false;
    },
    searchWithUserType(value) {
      // console.log('value', value);
      this.showUserTypeLabel = false;
      if (value && value.length > 0) {
        this.showUserTypeLabel = true;
      }
    },
    removeTag() {
      this.checkOnUpdate = false;
    },
    async onSubmit() {
      this.submitted = true;
      const { createUser, updateUserAction, userPhone, update } = this;
      const { entity_id } = this.form.entity;
      const {
        user_user_id,
        first_name,
        last_name,
        email,
        phone,
        image,
        // rfid_number,
        user_type_id,
        system_user,
        password,
        // company_name,
        // vehicle_registration,
        role_id,
        is_image_changed,
        rfidArr,
        labelArr,
      } = this.form.user;

      let formData = new FormData();
      formData.append("entity_id", entity_id);
      formData.append("user_user_id", user_user_id);
      formData.append("first_name", first_name);
      formData.append("last_name", last_name);
      // formData.append("company_name", company_name ? company_name : '');
      // formData.append( "vehicle_registration", vehicle_registration ? vehicle_registration : '');
      (email || update) && formData.append("email", email ? email : "");
      (userPhone || update) && formData.append("phone", userPhone ? phone : "");
      if (image || update) {
        formData.append("image", image ?? "");
        formData.append("is_image_changed", is_image_changed);
      }

      if (rfidArr.length) {
        for (let i = 0; i < rfidArr.length; i++) {
          formData.append("rfid_number[]", rfidArr[i]);
        }
      } else {
        formData.append("rfid_number", "");
      }

      if (labelArr.length) {
        const promises = [];
        for (let i = 0; i < labelArr.length; i++) {
          const labelExist = this.allLabels.find(
            (item) => item.name == labelArr[i]
          );
          if (!labelExist) {
            const addLabelPromise = this.addLabel({
              entity_id: this.currentEntity.id,
              name: labelArr[i],
            }).then((res) => {
              formData.append("labels[]", res.data.id);
            });
            promises.push(addLabelPromise);
          } else {
            formData.append("labels[]", labelExist.id);
          }
        }

        // Wait for all promises to complete before proceeding
        await Promise.all(promises);
      } else {
        formData.append("labels", "");
      }

      // (rfidArr.length || update) && formData.append("rfid_number", rfidArr.length > 0 ? rfidArr : '');
      formData.append("user_type_id", user_type_id ? user_type_id : "");
      formData.append("system_user", system_user == true ? 1 : 0);
      formData.append("role_id", role_id ? role_id.id : "");
      password && formData.append("password", password);
      // console.log("formData", formData, this.form.user);

      let customFields = getCustomFieldsPayload(this.customSections);
      formData.append(
        "custom_fields",
        customFields.length ? JSON.stringify(customFields) : ""
      );

      if (update) {
        // console.log('updateupdate');
        updateUserAction({ id: this.data.id, user: formData }).then(() => {
          this.$emit("changeUserStatusOrDeleted", this.form.user);
        });
      } else {
        createUser(formData).then(() => {
          this.$emit("changeUserStatusOrDeleted");
        });
      }
      // this.fetchCropImageData({});
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
      this.form.user.phone = this.userPhone
        ? `${this.userCountryCode}${this.userPhone}`
        : null;
      this.checkDuplicationData("phone");
    },
    onChangeToUpdatePhone() {
      this.currentPhone = false;
      this.form.user.phone = null;
    },
    async pickImage() {
      // document.getElementById('imagePicker').click();
      let backupData = {
        backup: true,
        id: this.form.user.id,
        first_name: this.form.user.first_name,
        last_name: this.form.user.last_name,
        email: this.form.user.email,
        phone: this.form.user.phone,
        userCountryCode: this.userCountryCode,
        user_type: this.form.user.user_type_id,
        // rfid_number: this.form.user.rfid_number,
        rf_ids: this.form.user.rf_ids,
        rfidArr: this.form.user.rfidArr,
        labelArr: this.form.user.labelArr,
        user_user_id: this.form.user.user_user_id,
        system_user: this.form.user.system_user,
        department_id: this.form.user.department_id,
        company_name: this.form.user.company_name,
        vehicle_registration: this.form.user.vehicle_registration,
        role_id: this.form.user.role_id,
        current_entity: this.getModalInfo.current_entity,
        is_image_changed: this.$v.form.user.is_image_changed.$model,
        image: this.form.user.image,
        size: this.image.size,
        height: this.image.height,
        width: this.image.width,
        url: this.image.url,
      };

      console.log("backupData", backupData);
      this.$emit("storeBackupUserData", backupData);
      // setTimeout(()=>{
      // this.$bvModal.hide("add-edit-user");

      await this.$bvModal.show("cropImageModal");
      // },100)
      await setTimeout(() => {
        var el = document.querySelector(
          ".cropper-container .cropper-crop-box .cropper-face"
        );
        if (el) el.style.borderRadius = "50%";
        // document.getElementById('cropImageSelectionBtn').click();
      }, 10);
    },
    removeUserImage() {
      this.image.url = null;
      this.form.user.image = null;
      this.$v.form.user.is_image_changed.$model = true;
      this.checkOnUpdate = false;
      this.submitted = false;
      // setTimeout(()=>{
      //   this.$refs.userImageRef.value = [];
      // },100)
      // this.fetchCropImageData({});
    },
    setResetModal() {
      this.$bvModal.hide("add-edit-user");
    },
    openUserRoleList() {
      this.openAndCloseUserRoleList = false;
    },
    closeUserRoleList() {
      this.openAndCloseUserRoleList = true;
    },
  },
  async beforeMount() {
    const res = await sectionService.getMainSectionTitle();
    if(res.data && res.data.name) this.mainSectionTitle = res.data.name;
    else this.mainSectionTitle = "Main Section";

    this.form.entity.entity_id = this.currentEntity.id;

    const { data } = await userTypeService.getPermittedUserTypes();

    data?.forEach((item) => {
      if (!item?.children?.length) delete item.children;
      this.userTypes.push(item);
    });
  },
};
</script>

<style lang="scss">
:dir(rtl)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  .user-custom-form-wizard
  .wizard-card-footer
  .wizard-footer-left
  button {
  inset-inline-start: 90px !important;
}
:dir(ltr)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  .user-custom-form-wizard
  .wizard-card-footer
  .wizard-footer-left
  button {
  inset-inline-start: 130px !important;
}

:dir(rtl)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  button.wizard-btn.next-btn {
  inset-inline-end: 130px;
}
:dir(ltr)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  button.wizard-btn.next-btn {
  // inset-inline-end: 15px;
}

:dir(rtl)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  .user-custom-form-wizard
  .wizard-nav {
  inset-inline-start: 46%;
}
:dir(ltr)
  div#add-edit-user
  div#add-edit-user___BV_modal_content_
  div#add-edit-user___BV_modal_body_
  .user-custom-form-wizard
  .wizard-nav {
  inset-inline-start: 51%;
}
// @import "@/design/user_form_modals.scss";
.not-allowed-cursor {
  cursor: not-allowed;
}

div#add-edit-user {
    div#add-edit-user___BV_modal_content_ {
      width: 500px!important;
      background: #FFFFFF;
      box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
      border-radius: 26px !important;
      
      .is-invalid .md-field.md-theme-default.md-has-value {
       width: 284px !important;
      }

    input[type="number"]::-webkit-inner-spin-button {
      height: 20px;
      position: absolute;
      inset-inline-start: 375px;
      bottom: 10px;
      opacity: 0.7;
      padding: 3px;
      margin-bottom: 3px;
    }
    div#add-edit-user___BV_modal_body_ {
      .multiselect__content-wrapper {
        overflow: hidden;
      }

      .treeselect.vue-treeselect.vue-treeselect--single.vue-treeselect--searchable.vue-treeselect--open-below.required-treeselect.treeselect-loading {
        .vue-treeselect__control-arrow-container {
          display: none;
        }
      }

      .userTypes-users {
        padding-inline-end: 10px;
      }
      div#label {
        .multiselect__select::before {
          display: none;
        }
      }
      div#rfid {
        .multiselect__select {
          display: none;
        }
      }
      .label-tag {
        position: relative;

        i.multiselect__tag-icon:hover {
          background: #f46a6a !important;
        }
        .selections-label {
          position: absolute;
          color: #103f5e;
          margin-top: 10px;
          margin-inline-end: 0;
          margin-bottom: 0;
          margin-inline-start: 20px;
          z-index: 99;

          font-size: 12px;
          font-weight: 700;
          line-height: 17px;
          letter-spacing: 0.25px;
          text-align: start;
        }
        .multiselect {
          width: 416px;
          border-radius: 4px !important;
        }
        .multiselect .multiselect__select {
          top: 7px !important;
        }
        .multiselect .multiselect__tags {
          min-height: 55px !important;
          background: #f2f2f2 !important;
          border-radius: 4px !important;
          border: none !important;
          display: grid;
          align-items: center;
        }
        .multiselect .multiselect__tag {
          font-size: 16px !important;
          line-height: 17px !important;

          font-weight: 700 !important;
          letter-spacing: 0.25px !important;
          padding-top: 10px !important;
          padding-inline-end: 48px !important;
          padding-bottom: 12px !important;
          padding-inline-start: 20px !important;
          border-radius: 6px !important;
          max-width: 376px;
        }
        .multiselect .multiselect__tag:first-child {
          margin-top: 25px;
          margin-inline-start: 5px !important;
        }
        .multiselect .multiselect__tag i.multiselect__tag-icon {
          width: 32px;
          font-size: 22px;

          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: center;
        }
        .multiselect__tag-icon:after {
          font-size: 22px;
          color: #f8f9fa !important;
        }
        .multiselect__input {
          background: #f2f2f2 !important;
          font-size: 16px !important;
          font-weight: 700 !important;
        }

        .multiselect__placeholder {
          color: #787878 !important;
          font-size: 16px;
          font-weight: 400 !important;

          line-height: 17px;
          padding-inline-start: 3px;
        }
      }

      .rfid-tag {
        position: relative;

        i.multiselect__tag-icon:hover {
          background: #f46a6a !important;
        }
        .selections-label {
          position: absolute;
          color: #103f5e;
          margin-top: 10px;
          margin-inline-end: 0;
          margin-bottom: 0;
          margin-inline-start: 20px;
          z-index: 99;

          font-size: 12px;
          font-weight: 700;
          line-height: 17px;
          letter-spacing: 0.25px;
          text-align: start;
        }
        .multiselect {
          width: 416px;
          border-radius: 4px !important;
        }
        .multiselect .multiselect__select {
          top: 7px !important;
        }
        .multiselect .multiselect__tags {
          min-height: 55px !important;
          background: #f2f2f2 !important;
          border-radius: 4px !important;
          border: none !important;
          display: grid;
          align-items: center;
        }
        .multiselect .multiselect__tag {
          font-size: 16px !important;
          line-height: 17px !important;

          font-weight: 700 !important;
          letter-spacing: 0.25px !important;
          padding-top: 10px !important;
          padding-inline-end: 48px !important;
          padding-bottom: 12px !important;
          padding-inline-start: 20px !important;
          border-radius: 6px !important;
          max-width: 376px;
        }
        .multiselect .multiselect__tag:first-child {
          margin-top: 25px;
          margin-inline-start: 5px;
        }
        .multiselect .multiselect__tag i.multiselect__tag-icon {
          width: 32px;
          font-size: 22px;

          display: flex;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          justify-content: center;
        }
        .multiselect__tag-icon:after {
          font-size: 22px;
          color: #f8f9fa !important;
        }
        .multiselect__input {
          background: #f2f2f2 !important;
          font-size: 16px !important;
          /* color: red !important; */
          font-weight: 700 !important;
        }

        .multiselect__placeholder {
          color: #787878 !important;
          font-size: 16px;
          font-weight: 400 !important;

          line-height: 17px;
          padding-inline-start: 3px;
        }
      }

      .back-next-dots {
        margin-top: 40px;
      }
      div#rfid-tag-add {
        height: 55px !important;
        background: #f2f2f2 !important;
        border-radius: 4px !important;
      }
      button.wizard-btn.next-btn {
        position: relative;
        float: inline-end;
        min-width: 36px;
        //top: 4px;
        background: transparent !important;
        border: none !important;
      }
      .wizard-nav li {
        margin-inline-end: 6px !important;
      }
      button.wizard-btn.add-edit-wizard:disabled {
        opacity: 1 !important;
        background: #9fb2bf !important;
        cursor: not-allowed;
      }
      button.wizard-btn.add-edit-wizard {
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;

        text-align: center;
        letter-spacing: 0.25px;
        width: 416px !important;
        height: 44px;
        border: none;
        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        color: #ffffff;
        border-radius: 22px;
        margin: 0px !important;
        padding: 0px !important;
        background-color: #103f5e;
      }
      .user-custom-form-wizard .wizard-card-footer .wizard-footer-left button {
        float: inline-start;
        position: relative;
        //top: 2px!important;
        min-width: 36px;
      }

      .wizard-btn.next-btn,
      .wizard-btn.back-btn {
        color: #103f5e !important;
        padding: 0;

        letter-spacing: 0.25px;
        line-height: 17px;
        font-weight: 700;
        border: none !important;
        background-color: transparent !important;
        font-size: 16px !important;
        color: #103f5e;
      }
      .wizard-btn.next-btn:disabled,
      .wizard-btn.back-btn:disabled {
        color: #103f5e !important;
        opacity: 0.4 !important;
        cursor: not-allowed;
      }
      .footer-submit-button {
        // margin-inline-start: 38px;
        .wizard-btn {
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;

          text-align: center;
          letter-spacing: 0.25px;

          color: rgba(255, 255, 255, 0.87);
          height: 44px !important;
          background: #103f5e !important;
          width: 415px !important;
          margin-inline-start: -9px;
          border-radius: 22px !important;
          padding: 0 !important;
          margin-bottom: 38px;
        }
      }
      .user-custom-form-wizard {
        padding: 0;
        position: relative;
        // overflow-x:hidden;
        // height: 600px;
        .wizard-progress-with-circle {
          display: none;
        }

        .wizard-tab-content {
          position: relative !important;
          // bottom: 0;
          // inset-inline-end: 0px;
        }

        .wizard-nav {
          flex-wrap: nowrap !important;
          position: absolute !important;
          transform: translate(-50%, -50%);
          bottom: 118px;
          margin-bottom: 0 !important;
          li {
            margin-inline-end: 6px;
            margin-top: 0;
            .wizard-icon-circle {
              background-color: #c7c7c7;
              border-color: #c7c7c7;
            }
            a {
              .wizard-icon-circle {
                height: 7px;
                width: 7px;
                .wizard-icon-container {
                  .wizard-icon {
                    display: none !important;
                  }
                }
                .wizard-icon {
                  display: none !important;
                }
              }
            }
          }
        }
        .active .wizard-icon-circle {
          background: #103f5e !important;
          border-color: #103f5e !important;
          color: #103f5e !important;
        }
        .wizard-tab-content,
        .wizard-card-footer {
          padding: 0 !important;
        }
        .wizard-card-footer {
          .wizard-btn.next-btn:disabled {
            background-color: transparent !important;
            border: none !important;
            cursor: not-allowed;
            opacity: 0.4 !important;
          }
        }

        .wizard-card-footer {
          .wizard-footer-left,
          .wizard-footer-right {
            transform: translate(-50%, -50%);
            position: relative;
          }
        }
      }
      .wizard-btn.next-btn,
      .wizard-btn.back-btn {
        color: #103f5e !important;
      }
      .wizard-btn.next-btn:disabled,
      .wizard-btn.back-btn:disabled {
        color: #103f5e !important;
        cursor: not-allowed;
        opacity: 0.4 !important;
      }
      .vue-form-wizard .wizard-btn {
        margin: 0px !important;
        padding: 0px !important;
      }
      .vue-form-wizard .wizard-tab-content {
        padding: 0px !important;
        height: auto !important;
      }
      .vue-form-wizard {
        padding-bottom: 40px !important;
      }
      .vue-form-wizard .wizard-card-footer {
        padding: 0px !important;
        margin: auto;
        width: 416px;
      }
      .usertype-treeselect-container {
        position: relative;
      }
      .usertype-treeselect-spinner {
        position: absolute;
        top: 5%;
        inset-inline-end: -1%;
        z-index: 10;
        background-color: #f2f2f2;
      }
      .main-section {
        height: 17px;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 40px;
        line-height: 17px;
        color: #787878;
      }
      .rfid-tags-add {
        .multiselect__content-wrapper::-webkit-scrollbar {
          width: 9px;
          height: 10px !important;
        }
        .multiselect__content-wrapper::-webkit-scrollbar-track {
          background: #c7c7c7;
          padding-top: 30px !important;
          border-radius: 8.5px;
          -webkit-box-shadow: #ffff;
          margin-top: 21px !important;
          margin-bottom: 13px !important;
        }
        .multiselect__content-wrapper::-webkit-scrollbar-thumb {
          background: #666666;
          border-radius: 8.5px;
        }
      }

      padding: 0px !important;

      .m-d-gruop > input:focus {
        opacity: 1;
      }

      .vue-country-select{
        z-index: 99 !important;
      }
      .activeLoader {
        opacity: 0.4;
        cursor: not-allowed;
      }
      .modal-title-head {
        .title-head {
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          margin: 40px auto 40px auto;
          color: #000000;
          // margin-inline-end: 160px;
          p {
            font-weight: 700;
            font-size: 17px;
            line-height: 20px;
          }
        }
        .withImage {
          font-weight: 700;
          font-size: 17px;
          line-height: 20px;
          margin: 40px auto 64px auto;
          color: #000000;
          margin-inline-end: 141px;
          p {
            font-weight: 700;
            font-size: 17px;
            line-height: 20px;
          }
        }
      }

      .closeAddUserModal {
        position: absolute;
        top: 32px;
        inset-inline-end: 32px;
        cursor: pointer;
      }

      .personal-user-informatoin {
        margin: auto;
        width: 416px;
        .default-user {
          width: 416px;
          margin: auto;
        }
      }

      .phone-input-wrapper {
        display: grid;
        // grid-template-columns: 106px 294px;
        height: 55px !important;
        margin-bottom: 14px !important;
      }

      .spinner-border {
        margin-inline-start: 10px;
        margin-top: 5px !important;
        height: 18px;
        width: 18px;
        z-index: 1000 !important;
      }

      .rfid-spinner-border {
        margin-inline-start: 10px;
        margin-top: 10px;
        height: 20px;
        width: 20px;
        z-index: 1000 !important;
      }
      .phone-email-loader {
        float: inline-end;
        margin-top: -28px;
        margin-inline-end: 7px;
      }

      .rfid-loader {
        float: inline-end;
        margin-top: -51px;
        margin-inline-end: -30px;
      }

      .generate-user-id {
        width: 286px !important;
        margin-inline-end: 15px !important;
      }

      .generate-user-id-btn {
        width: 115px !important;
        height: 55px !important;
        inset-inline-start: 812px;
        top: 663px;
        border: none;
        /* Main Button */

        background: #103f5e;
        border-radius: 4px;

        font-weight: 700;
        font-size: 16px;
        line-height: 17px;
        letter-spacing: 0.25px;
        color: #ffffff;
        &:disabled {
          background: #103f5e;
          opacity: 0.4 !important;
          border: none;
          cursor: not-allowed;
        }
      }
      .error-message {
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        letter-spacing: 0.25px;
        color: #f46a6a;
        margin-inline-start: 20px;
        margin-top: -17px;
        margin-bottom: 16px;
      }

      input#phoneNumber {
        &:disabled {
          background: transparent;
          opacity: 0.4 !important;
        }
      }
      .m-d-gruop > .form-control:disabled ~ label {
        font-weight: 700 !important;
        font-size: 10px !important;
        line-height: 17px !important;
        /* or 170% */

        letter-spacing: 0.25px !important;

        bottom: 38px;
        color: #103f5e !important;

        opacity: 0.4 !important;
      }

      input#phone:disabled,
      input#email:disabled {
        // background: red!important;

        font-weight: 600 !important;
        font-size: 14px !important;
        line-height: 17px !important;
        /* identical to box height, or 121% */

        letter-spacing: 0.25px !important;

        color: rgba(0, 0, 0, 0.87) !important;

        opacity: 0.4 !important;
      }
      .is-invalid {
        border: 1.5px solid #f46a6a !important;
        border-radius: 4px;
        height: 58px;
      }
      input#userRole {
        background: #f2f2f2 !important;

        font-weight: 700 !important;
        font-size: 16px !important;
        line-height: 17px !important;
        /* identical to box height, or 106% */

        letter-spacing: 0.25px;

        color: rgba(0, 0, 0, 0.87) !important;

        opacity: 0.8 !important;
      }

      .systemUserHint {
        hr {
          width: 415px;
          margin: auto;
        }
      }
      .all-user-data {
        width: 416px;
        margin: auto;
      }

      .code-input {
        background: #f2f2f2;
        border: none;
        border-radius: 4px !important;
        height: 55px !important;
        width: 115px !important;
        // margin-inline-start: 14px !important;
      }

      .phone-input {
        width: 286px !important;
        margin-inline-start: auto;
        background: #f2f2f2;
        border: none;
        border-radius: 4px !important;
        height: 55px !important;
        margin-inline-start: 14px !important;
      }

      .mb-14 {
        margin-bottom: 14px !important;
      }

      .multiselect__content-wrapper::-webkit-scrollbar {
        width: 9px;
        height: 30px !important;
      }
      .multiselect__content-wrapper::-webkit-scrollbar-track {
        background: #c7c7c7;
        padding-top: 30px !important;
        border-radius: 8.5px;
        -webkit-box-shadow: #ffff;
        margin-top: 21px !important;
        margin-bottom: 13px !important;
      }
      .multiselect__content-wrapper::-webkit-scrollbar-thumb {
        background: #666666;
        border-radius: 8.5px;
      }

      .selections-label {
        position: absolute;
        color: #103f5e;
        margin-top: 10px;
        margin-inline-end: 0;
        margin-bottom: 0;
        margin-inline-start: 20px;
        z-index: 99;

        font-size: 12px;
        font-weight: 700;
        line-height: 17px;
        letter-spacing: 0.25px;
        text-align: start;
      }

      .highZIndex {
        z-index: 99;
      }

      .vue-treeselect__menu::-webkit-scrollbar {
        width: 9px;
        height: 30px !important;
      }
      .vue-treeselect__menu::-webkit-scrollbar-track {
        background: #c7c7c7;
        padding-top: 30px !important;
        border-radius: 8.5px;
        -webkit-box-shadow: #ffff;
        margin-top: 5px !important;
        margin-bottom: 13px !important;
      }
      .vue-treeselect__menu::-webkit-scrollbar-thumb {
        background: #666666;
        border-radius: 8.5px;
      }

      .rfid-notes {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.25px;
        color: #787878;
        margin-bottom: 16px;
        margin-top: 8px;
        margin-inline-start: 20px;
      }

      .mb-14 {
        margin-bottom: 14px !important;
      }

      .action-btns {
        .add-document-btn {
          width: 415px;
          margin-top: 28px;
          margin-bottom: 38px;
          border-radius: 22px;
          background-color: #103f5e;
          font-weight: 700;
          font-size: 16px;
          line-height: 17px;
          color: #ffffff;
          height: 44px;
        }
        .add-document-btn:disabled {
          cursor: not-allowed;
          opacity: 0.4;
        }
      }
    }
  }
}

label#vehicleRegistration__BV_label_ {
  white-space: pre-wrap;
}

#fileInput {
  display: none;
}
.upload-icon {
  cursor: pointer;
  font-size: 2.1rem;
  color: #4a4a4a;
  margin-inline-start: 0.8rem;
  transition: 0.5s;
  &:hover {
    color: #103f5e;
  }
}
.spinner-grow {
  width: 5.8rem;
  height: 5.8rem;
}
.change-text {
  text-decoration: underline !important;
  color: #50a5f1;
}
.delete-icon {
  font-size: 1.3rem;
  margin-inline-start: 8px;
  cursor: pointer;
}
.system-user-text {
  margin-bottom: 0;
  margin-inline-end: 5px;
  font-weight: bold;
}
.user-types-select {
  z-index: 1100;
}
.user-roles {
  z-index: 999;
}

.img-bg {
  width: 383px;
  height: 107px;
  border: none;
  background: #000000;
  opacity: 0.45;
  border-radius: 18px;
  position: relative;
}

.camera-BG {
  display: inline-flex;
  width: 106px;
  height: 106px;
  align-items: center;
  justify-content: center;
  background: #f2f2f2;
  border-radius: 50%;
  text-align: center;
  //margin-bottom: 12px;
  border: none;
}

.red-border {
  border: 1.5px solid #f46a6a;
}

.userImage {
  border-radius: 50% !important;
  width: 106px !important;
  height: 106px !important;
}

.remove-user-image-btn {
  top: 175px;
  inset-inline-start: 45%;
  width: 68px;
  height: 25px;
  border: none;
  color: #fff;

  font-weight: 600;
  font-size: 16px;
  line-height: 17px;
  text-align: center;

  color: #f46a6a;
  z-index: 5 !important;
  margin-top: 9px !important;
  letter-spacing: 0.25px;
  font-style: normal !important;
}

.user-camera {
  position: absolute;
  inset-inline-start: 40% !important;
  top: 35% !important;
  color: #ffffff !important;
  opacity: 0.65 !important;
  font-size: 25px;
}

.no-user-camera {
  color: #8c8c8c !important;
  opacity: 0.65 !important;
  font-size: 25px;
}

.user-image-message {
  width: 304px;

  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  margin-inline-start: 30px;
  /* or 142% */

  text-align: center;
  letter-spacing: 0.25px;

  /* #939393 */

  color: #939393;

  opacity: 0.8;
}

.header-close {
  font-size: 24px !important;
  font-weight: bold !important;
  background-color: transparent;
  border: none;
}

.header-close:active {
  outline: none;
}
</style>
